import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { TechRequest } from "@/pages/tech/TechRequest";
import { TechDdt } from "@/pages/tech/TechDdt";

const TABS = { MATERIAL: "Materiali", DEVICE: "Apparati", TOOL: "Attrezzature" };
const has = (q, ...xs) => !q || xs.join(" ").toLowerCase().includes(q.toLowerCase());

const ItemLine = ({ it, q }) => (
  <div className="border-b py-2.5 last:border-b-0" data-testid={`tech-kit-item-${it.code}`}>
    <div className="flex items-start justify-between gap-3 text-sm">
      <span><span className="font-mono text-xs">{it.code}</span> · {it.name}</span>
      <span className={`shrink-0 font-mono font-semibold ${it.qty < 0 ? "text-red-700" : ""}`}>{it.qty} {it.unit}</span>
    </div>
    {it.serials.length > 0 && (
      <div className="mt-1.5 flex flex-wrap gap-1.5">
        {it.serials.filter((s) => has(q, it.code, it.name, s.serial, s.customer)).map((s) => (
          <span key={s.serial} className="border bg-muted px-1.5 py-0.5 font-mono text-[11px]" data-testid={`tech-kit-serial-${s.serial}`}>{s.serial}{s.customer && <span className="ml-1 font-sans text-muted-foreground">· {s.customer}</span>}</span>
        ))}
      </div>
    )}
  </div>
);

const Assigned = ({ list }) => (
  <section className="mt-4 border bg-white p-4" data-testid="tech-kit-assigned">
    <div className="micro-label mb-2">Assegnati a me</div>
    {list.map((a, i) => (
      <div key={i} className="flex justify-between gap-3 border-b py-2.5 text-sm last:border-b-0">
        <span>{a.kind_label} · {a.name}{a.note && <span className="block text-xs text-muted-foreground">{a.note}</span>}</span>
        <span className="shrink-0 font-mono text-xs">{a.serial}</span>
      </div>
    ))}
  </section>
);

export const TechKit = () => {
  const [kit, setKit] = useState(null);
  const [tab, setTab] = useState("MATERIAL");
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/tech/my-kit").then((r) => setKit(r.data)).catch(() => setKit({ vans: [], assigned: [] })); }, []);
  if (!kit) return null;
  return (
    <div className="mt-6" data-testid="tech-kit">
      <TechRequest />
      <TechDdt />
      <div className="relative mb-3">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input className="h-11 pl-9" placeholder="Cerca codice, nome o seriale" value={q} onChange={(e) => setQ(e.target.value)} data-testid="tech-kit-search" />
      </div>
      <div className="grid grid-cols-3 border bg-white">
        {Object.entries(TABS).map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} className={`h-11 text-sm font-semibold transition-colors ${tab === k ? "bg-foreground text-background" : ""}`} data-testid={`tech-kit-tab-${k}`}>{l}</button>
        ))}
      </div>
      {kit.vans.map((v) => {
        const items = v.items.filter((it) => it.kind === tab && (has(q, it.code, it.name) || it.serials.some((s) => has(q, s.serial, s.customer))));
        return (
          <section key={v.id} className="mt-4 border bg-white p-4" data-testid={`tech-kit-van-${v.id}`}>
            <div className="micro-label mb-2">{v.name} · {items.length} articoli</div>
            {items.map((it) => <ItemLine key={it.item_id} it={it} q={q} />)}
            {!items.length && <p className="text-sm text-muted-foreground">Nessun articolo.</p>}
          </section>
        );
      })}
      {!kit.vans.length && <div className="mt-4 border bg-white p-4 text-sm text-muted-foreground">Nessun furgone assegnato.</div>}
      {tab === "TOOL" && kit.assigned.length > 0 && <Assigned list={kit.assigned} />}
    </div>
  );
};
